/**
 * Query parameter names for attribution tracking
 */
export enum TrackingParam {
  UTM_SOURCE = 'utm_source',
  UTM_MEDIUM = 'utm_medium',
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_TERM = 'utm_term',
  UTM_CONTENT = 'utm_content',
  GCLID = 'gclid',
  FBCLID = 'fbclid',
}
